/*
 *  GENERAL APP LINKS
 */

/**
 * Indique si l'utilisateur courant a acces au menu identifie par `code`
 * (un permission_code de type "show_*").
 *
 * Regle metier (cf BusinessPrivilegePermission cote backend) :
 *   - superuser / company_owner / administrator / manager -> acces total
 *   - operateur SANS aucun privilege configure         -> acces total
 *   - operateur AVEC privileges configures             -> acces si codes.has(code)
 */
function userHasMenu($, code) {
  if (!$ || !$.$store) return true
  const store = $.$store
  if (store.getters["app/isUserSuperUser"]) return true
  if (store.getters["app/isCompanyOwner"]) return true
  const company = store.getters["app/getCompany"]
  const role = company && company.company_role
  if (role === "administrator" || role === "manager") return true
  const privileges = store.state.app && store.state.app.userPrivileges
  // Operateur sans aucune entree Privilege -> acces total par defaut (mirroir
  // du fallthrough cote backend).
  if (!Array.isArray(privileges) || privileges.length === 0) return true
  const hasAnyAction = privileges.some(p => {
    const acts = (p && (p.actions || p.action)) || []
    return Array.isArray(acts) ? acts.length > 0 : !!acts
  })
  if (!hasAnyAction) return true
  const codes = store.getters["app/userPrivilegeCodes"]
  return !!(codes && codes.has && codes.has(code))
}

export { userHasMenu }

export const APP_DRAWER_TOP = [
  {
    to: { name: "Home" },
    title: "commons.drawer.home",
    icon: "mdi-home"
  },
  {
    to: { name: "Projects" },
    title: "commons.drawer.projects",
    icon: "mdi-folder-open"
  },
  {
    to: { name: "TemplateList" },
    title: "commons.drawer.forms_editing",
    icon: "mdi-calendar-text"
  },
  {
    to: { name: "DashboardReports" },
    title: "commons.drawer.statistics",
    icon: "mdi-chart-bar"
  },
  {
    icon: "mdi-chart-gantt",
    to: { name: "GanttAdmin" },
    title: "commons.drawer.gantt"
  }
]

export const APP_DRAWER_BOTTOM = [
  {
    to: { name: "Administration" },
    title: "commons.drawer.administration",
    icon: "mdi-account-cog-outline",
    // isAllowed: $ => $.$store.getters["app/isCompanyOwner"]
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "Admin" },
    title: "commons.drawer.admin",
    icon: "mdi-security",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    disabled: true,
    to: { name: "Help" },
    title: "commons.drawer.help",
    icon: "mdi-help"
  }
]

/*
 *  USER ADMINISTRATION LINKS
 */
export const ADMINISTRATION_DRAWER_TOP = [
  {
    to: { name: "AdministrationUsers" },
    title: "commons.drawer.users",
    icon: "mdi-account-group"
  },
  {
    to: { name: "AdministrationUsersPending" },
    title: "commons.drawer.userPending",
    icon: "mdi-email-alert-outline"
  },
  {
    to: "#",
    title: "commons.drawer.facturation",
    icon: "mdi-credit-card-check-outline"
  }
]

/*
 *  ADMIN LINKS
 */
export const ADMIN_DRAWER_TOP = [
  {
    to: { name: "AdminSummary" },
    title: "commons.drawer.summary",
    icon: "mdi-home-analytics",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    icon: "mdi-domain",
    to: { name: "PartnerCompany" },
    title: "Entreprises",
    tooltip: "Clients",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    icon: "mdi-account-group-outline",
    to: { name: "AdminUsers" },
    title: "Utilisateurs",
    tooltip: "Utilisateurs",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    icon: "mdi-card-account-details-outline",
    to: { name: "PhysicalCardsAdmin" },
    title: "Cartes",
    tooltip: "Cartes Physiques",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    icon: "mdi-truck-fast-outline",
    to: { name: "AdminVehicles" },
    title: "Vehicules",
    tooltip: "Vehicules",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    icon: "mdi-account-supervisor-circle-outline",
    to: { name: "AdminVouchers" },
    title: "Bons Emis",
    tooltip: "Bons Emis",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
    //isAllowed: $ => !$.$store.getters["app/isUserPro"] icon: "mdi-swap-horizontal", PhysicalCardsAdmin
  },
  {
    to: { name: "AdminValidation" },
    title: "Validations",
    icon: "mdi-account-plus",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "AdminActions" },
    title: "commons.drawer.privilege",
    icon: "mdi-check-decagram-outline",
    isAllowed: $ => $.$store.getters["app/isUserSuperUser"]
  },
  {
    to: { name: "AdminActivities" },
    title: "Transactions",
    icon: "mdi-swap-horizontal",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "AdminDonations" },
    title: "Dons",
    icon: "mdi-gift-outline",
    tooltip: "Gestion des dons",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "AdminOcrCorrected" },
    title: "Corrections OCR",
    icon: "mdi-auto-fix",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "AdminActivityAdjustments" },
    title: "Approbations",
    icon: "mdi-check-network-outline",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "AdminAnnouncements" },
    title: "Communiques",
    icon: "mdi-bullhorn",
    tooltip: "Gestion des annonces",
    isAllowed: $ => $.$store.getters["app/isUserStaff"],
  },
  {
    icon: "mdi-handshake-outline",
    to: { name: "PartnerCards" },
    title: "Partnaires",
    tooltip: "Partnaires",
    isAllowed: $ => $.$store.getters["app/isUserSuperUser"]
  }
]

/*
 *  PROJECT LINKS WITHOUT PCQ
 */

export const PROJECT_DRAWER_TOP = [
  {
    icon: "mdi-home",
    to: { name: "Home" },
    title: "Tableau de bord",
    tooltip: "Tableau de bord",
    isAllowed: $ => !$.$store.getters["app/isUserPro"]
  },
  {
    to: { name: "CompanyDepartment" },
    title: "Départements",
    icon: "mdi-apps",
    isAllowed: $ => !$.$store.getters["app/isUserPro"]
      && userHasMenu($, "show_department")
  },
  {
    icon: "mdi-map-marker-radius-outline",
    to: { name: "ShopDetail" },
    title: "Stations / Produits",
    tooltip: "Sites, Magasin, Station",
    isAllowed: $ => {
      if ($.$store.getters["app/isUserPro"]) return false
      const company = $.$store.getters["app/getCompany"]
      // Les societes partenaires (stations / fournisseurs) ne gerent pas
      // leurs sites / produits depuis cet espace.
      if (company && company.company_type === "Partners") return false
      return userHasMenu($, "show_shops") || userHasMenu($, "show_products")
    },
    children: [
      {
        to: { name: "ShopDetail" },
        title: "Dénomination du site",
        tooltip: "Dénomination du site"
      },
      {
        to: { name: "ProductDetail" },
        title: "Prix Produits",
        tooltip: "Prix Produits",
        isAllowed: $ => !$.$store.getters["app/isUserPro"]
      },
      {
        to: { name: "CityDetail" },
        title: "Villes",
        tooltip: "Villes"
      },
      {
        to: { name: "MunicipalityDetail" },
        title: "Communes",
        tooltip: "Communes"
      }
    ]
  },
  {
    icon: "mdi-barrel-outline",
    to: { name: "TankList" },
    title: "Cuves",
    tooltip: "Gestion des cuves",
    isAllowed: $ => {
      const company = $.$store.getters["app/getCompany"];
      const canServed = Boolean(company && company.can_served);
      return canServed && userHasMenu($, "show_tanks");
    },
  },
  {
    icon: "mdi-account-group-outline",
    to: { name: "StaffMembers" },
    title: "commons.drawer.personnels",
    tooltip: "nav.title.personnel_list",
    isAllowed: $ => !$.$store.getters["app/isUserPro"]
      && userHasMenu($, "show_personnels")
  },
  {
    icon: "mdi-car-cog",
    to: { name: "CompanyVehicles" },
    title: "Vehicules",
    tooltip: "Vehicules",
    isAllowed: $ => !$.$store.getters["app/isUserPro"]
      && userHasMenu($, "show_vehicules")
  },
  {
    icon: "mdi-medal",
    to: { name: "RedemptionsAdmin" },
    title: "Fidelités",
    tooltip: "Fidelités",
    isAllowed: $ => {
      const isUserPro = $.$store.getters["app/isUserPro"];
      const company = $.$store.getters["app/getCompany"];
      const canServed = Boolean(company && company.can_served);
      return !isUserPro && !canServed && userHasMenu($, "show_redemption");
    },
    children: [
      {
        to: { name: "RedemptionsAdmin" },
        title: "Gestion",
        tooltip: "Gestion"
      },
      {
        to: { name: "VehiclesUsers" },
        title: "Utilisateurs",
        tooltip: "Info des utilisateurs"
      },
      {
        to: { name: "FidelityStats" },
        title: "Statistiques",
        tooltip: "Statistiques fidélité"
      }
    ]
  },
  {
    icon: "mdi-license",
    to: { name: "CompanyVouchers" },
    title: "Crédit Carburant",
    tooltip: "Crédit Carburant",
    isAllowed: $ => !$.$store.getters["app/isUserPro"]
      && userHasMenu($, "show_purchase")
  },
  {
    icon: "mdi-account-supervisor-circle-outline",
    to: { name: "ClientVouchers" },
    title: "Data Crédit Clients",
    tooltip: "Data Crédit Clients",
    isAllowed: $ => {
      const isUserPro = $.$store.getters["app/isUserPro"];
      const company = $.$store.getters["app/getCompany"];
      const canServed = Boolean(company && company.can_served);
      return !isUserPro && !canServed && userHasMenu($, "show_client_voucher");
    },
  },
  {
    icon: "mdi-gift-outline",
    to: { name: "DonationDetail" },
    title: "Dons",
    tooltip: "Gestion des donations",
    isAllowed: $ => {
      const company = $.$store.getters["app/getCompany"]
      const donationsEnabled = !company || company === -1 || company.donations_enabled !== false
      return $.$store.getters["app/isUserStaff"]
        && donationsEnabled
        && userHasMenu($, "show_donation")
    }
  },
  {
    icon: "mdi-swap-horizontal",
    to: { name: "Historique" },
    title: "Historique",
    tooltip: "Historique",
    isAllowed: $ => {
      const company = $.$store.getters["app/getCompany"];
      const canServed = Boolean(company && company.can_served);
      return !canServed && userHasMenu($, "show_transaction");
    },
    children: [
      {
        to: { name: "TransactionDetail" },
        title: "B2B",
        tooltip: "B2B"
      },
      {
        to: { name: "FidelityDetail" },
        title: "Fidelités",
        tooltip: "Fidelités"
      }
    ]
  },
  {
    icon: "mdi-swap-horizontal",
    to: { name: "TransactionDetail" },
    title: "Historique",
    tooltip: "Historique",
    isAllowed: $ => {
      const company = $.$store.getters["app/getCompany"];
      const canServed = Boolean(company && company.can_served);
      return canServed && userHasMenu($, "show_transaction");
    },
  },
]

export const CLIENT_DRAWER_TOP = [
  {
    icon: "mdi-home",
    to: { name: "Home" },
    title: "commons.drawer.general",
    tooltip: "commons.drawer.general"
  },
  {
    to: { name: "CompanyDepartment" },
    title: "commons.drawer.company_department",
    icon: "mdi-apps",
    isAllowed: $ => userHasMenu($, "show_department")
  },
  {
    icon: "mdi-account-group-outline",
    to: { name: "StaffMembers" },
    title: "commons.drawer.personnels",
    tooltip: "nav.title.personnel_list",
    isAllowed: $ => userHasMenu($, "show_personnels")
  },
  {
    icon: "mdi-car-cog",
    to: { name: "CompanyVehicles" },
    title: "Vehicules",
    tooltip: "Vehicules",
    isAllowed: $ => userHasMenu($, "show_vehicules")
  },
  {
    icon: "mdi-license",
    to: { name: "CompanyVouchers" },
    title: "Crédit Carburant",
    tooltip: "Crédit Carburant",
    isAllowed: $ => userHasMenu($, "show_purchase")
  },
  {
    icon: "mdi-gift-outline",
    to: { name: "DonationDetail" },
    title: "Dons",
    tooltip: "Gestion des donations",
    isAllowed: $ => {
      const company = $.$store.getters["app/getCompany"]
      const donationsEnabled = !company || company === -1 || company.donations_enabled !== false
      return donationsEnabled && userHasMenu($, "show_donation")
    }
  },
  {
    icon: "mdi-swap-horizontal",
    to: { name: "TransactionDetail" },
    title: "commons.drawer.transaction",
    tooltip: "nav.title.timeline_list",
    isAllowed: $ => userHasMenu($, "show_transaction")
  },
]



export const PROJECT_DRAWER_BOTTOM = [
  {
    icon: "mdi-account-group-outline",
    to: { name: "CompanyMembers" },
    title: "commons.drawer.team",
    isAllowed: $ => !$.$store.getters["app/isUserPro"]
  },
  {
    icon: "mdi-key-variant",
    to: { name: "ApiKeys" },
    title: "Cles API",
    tooltip: "Gerer les cles API",
    isAllowed: $ => {
      if ($.$store.getters["app/isUserPro"]) return false
      // Le menu n'est visible que si le super admin a active les cles API
      // sur la societe.
      const company = $.$store.getters["app/getCompany"]
      if (!company || company === -1) return false
      if (company.api_keys_enabled !== true) return false
      if ($.$store.getters["app/isUserSuperUser"]) return true
      if ($.$store.getters["app/isCompanyOwner"]) return true
      const role = company.company_role
      return role === "administrator" || role === "manager"
    }
  }
]

/*
 *  TEMPLATE LINKS
 */
export const TEMPLATE_DRAWER_TOP = [
  {
    icon: "mdi-bookmark-multiple",
    to: { name: "TemplateList" },
    title: "commons.drawer.customize_templates"
  },
  {
    icon: "mdi-playlist-plus",
    to: { name: "FieldTypeEditor" },
    title: "commons.drawer.customize_fieldtypes"
  }
]

/*
 *  PROFILE LINKS
 */

export const PROFILE_DRAWER_TOP = [
  {
    to: { name: "Profile" },
    title: "commons.drawer.personal_settings",
    icon: "mdi-account-cog-outline"
  },
  {
    to: { name: "Logout" },
    title: "views.signup_in.signout",
    icon: "mdi-logout"
  }
]
